import { useState } from 'react';

import { statuses } from './filters';
import { LOCAL_FORMAT } from '../../utilities';
import { Dropdown, Datepicker } from '../../components';
import { Button, SubmitButton } from '../../components';
import { Modal, Form, FormItem } from '../../components';
import type { ItemType as FormType } from './useTasks';

type TaskModalProps = {
  loading: boolean;
  initialValues?: FormType;

  onClose: () => void;
  onSumbit: (payload: FormType) => void;
};

const dateFormat = LOCAL_FORMAT;

const TaskModal: React.FC<TaskModalProps> = ({
  loading,
  initialValues,
  onClose,
  onSumbit,
}) => {
  const [values, setValues] = useState(initialValues);

  return (
    <Form<FormType> initialValue={values} onChange={setValues}>
      <Modal
        open
        title={initialValues ? 'Edit Task' : 'Add Task'}
        onClose={onClose}
        bottomActions={
          <>
            <SubmitButton
              type="primary"
              loading={loading}
              onClick={() => values && onSumbit?.(values)}
            >
              Save
            </SubmitButton>
            <Button onClick={onClose}>Cancel</Button>
          </>
        }
      >
        <div className="flex flex-col gap-y-md pb-[28rem]">
          <FormItem<FormType> label="Scheduled At" name="scheduled_at">
            <Datepicker valueFormat={dateFormat} />
          </FormItem>
          <FormItem<FormType> label="Status" name="status">
            <Dropdown options={statuses} />
          </FormItem>
        </div>
      </Modal>
    </Form>
  );
};

export default TaskModal;
